import styled from 'styled-components';

export const Container = styled.div`

`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 1rem;
`;

export const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  color: #1a202c;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0.75rem;
`;

export const PreviewContainer = styled.div`
  width: 100%;
  height: 70vh;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  overflow: hidden;
`;

export const PreviewFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  background: white;
`;

